// eslint-disable-next-line simple-import-sort/imports
import { initWDYR } from './wdyr'
import { Theme } from '@radix-ui/themes' //Wrap the app in radix Theme to allow the use of components

import { ThemeColor } from 'utils/radix/theme-color' //Wrap the app in ThemeColor to allow the use of the theme

// eslint-disable-next-line simple-import-sort/imports
import 'core-js'
import 'regenerator-runtime/runtime'
import './styles/third-party.css'
// import order is important in this group, don't change it
// otherwise you will get an errors when working on dnd after refreshes
import React from 'react'
import { createRoot } from 'react-dom/client'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
// ----
import { Provider } from 'react-redux'
import { BrowserRouter, useLocation } from 'react-router-dom'
import GoogleAnalytics from '@disco/api/ga'
import Intercom from '@disco/api/intercom'
import { CookieConsentProvider } from 'contexts/cookie-consent'
import { IndicatorContextProvider } from 'contexts/indicator'
import { configureSharedDependencies } from '@disco/utils/configuration'
import { registerServiceWorker } from '@disco/utils/service-worker'
import routes from 'views/routes'
import configureStore from './store/configureStore'
import { CancellationBannerProvider } from 'components/common/subscribed-user-billing/cancel-subscription/CancellationBannerProvider'
import { RouterProvider } from 'views/components/common/router-provider'
import '@disco/i18n/i18next'

initWDYR()
window.host = window.backend
configureSharedDependencies()
const store = configureStore()
// React Router v6 doesn't need manual history management

function logPageView() {
  GoogleAnalytics.sendPageview()
  Intercom.update()
}

function PageViewTracker() {
  const location = useLocation()
  React.useEffect(() => {
    logPageView()
  }, [location])
  return null
}

registerServiceWorker()
const appRoot = (
  <Theme hasBackground={false}>
    <ThemeColor />
    <DndProvider backend={HTML5Backend}>
      <Provider store={store}>
        <CookieConsentProvider>
          <IndicatorContextProvider>
            <CancellationBannerProvider>
              <BrowserRouter>
                <RouterProvider>
                  <PageViewTracker />
                  {routes(store)}
                </RouterProvider>
              </BrowserRouter>
            </CancellationBannerProvider>
          </IndicatorContextProvider>
        </CookieConsentProvider>
      </Provider>
    </DndProvider>
  </Theme>
)
const root = createRoot(document.getElementById('app'))
root.render(appRoot)

if (module.hot) {
  module.hot.accept(
    ['views/routes', './store/configureStore', './contexts/cookie-consent'],
    () => {
      const nextRoutes = require('views/routes').default

      const nextAppRoot = (
        <Theme hasBackground={false}>
          <ThemeColor />
          <DndProvider backend={HTML5Backend}>
            <Provider store={store}>
              <CookieConsentProvider>
                <BrowserRouter>
                  <RouterProvider>
                    <PageViewTracker />
                    {nextRoutes(store)}
                  </RouterProvider>
                </BrowserRouter>
              </CookieConsentProvider>
            </Provider>
          </DndProvider>
        </Theme>
      )
      root.render(nextAppRoot)
    },
  )
}
